const cache = new Map();

export const getCachedData = (key) => cache.get(key);
export const setCachedData = (key, data) => cache.set(key, data);
export const clearCache = () => cache.clear();
export const clearCacheByKey = (key) => cache.delete(key);
